import React, { useEffect, useState, useContext } from 'react'
import { currencySymbolHendling, getFormattedMessage } from '../shared/sharedMethod';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem } from 'react-bootstrap';
import Table from "react-bootstrap/Table";
import moment from "moment";
import { darkColor, lightColor, lightColorLighter, mainColor, semiDarkColor } from '../constants/constans';
import ReactPrint from "../../components/ReactToPrint"
import TableComponentToPrint from 'components/TableJourneToPrint';
import Context from 'Context/context';
import { fetchListCommandeSite, fetchDetailComande ,updateCommandeStatus } from 'Fetch/products';
import EditHoldConfirmationModal from './EditHoldConfirmationModal';
import warning from "../../assets/images/warning.png"
import loader from "../../animaion/loader.json"
import NoData from "../../animaion/noData.json"
import Lottie from 'react-lottie';


const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};

const defaultOptions_ = {
    loop: true,
    autoplay: true,
    animationData: NoData,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};

function CommandeSiteModal(props) {
    const { commandeShow, onClickSiteCommadeModal } = props;

    const [items, setItems] = useState([]);
    const [selectedItemDetails, setSelectedItemDetails] = useState(null);
    const { productsPanier,setFraisGlobal, setProductPanier, addToast } = useContext(Context)
    const data = [
        {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175805",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        },
        {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175803",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        },
        {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175806",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        },
        {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        },
        {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        },
        {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }, {
            "id_serveur": "-1",
            "last_commande": "",
            "nb_commande": "0",
            "ca": "0",
            "user_id": "-1",
            "moyen_paiement": "0",
            "id": "175807",
            "prix_total": "79",
            "nom": "Nizar C.",
            "prenom": "GLOVO",
            "lat": "0",
            "lng": "0",
            "telephone": "Nizar C.",
            "type": "0",
            "created_at": "2024-01-25 14:51:49",
            "note": "769 ",
            "email": "glovo@lacaisse.ma",
            "adresse": "",
            "channel": "GLOVO",
            "orderid": "EKHDKHDKHA",
            "status": "0",
            "reduction": "-10",
            "tips": "0",
            "service": "0",
            "utm": "637666"
        }

    ]
    const [selectedDetailId, setSelectedDetailId] = useState(null);
    const [details, setDetails] = useState([]);
    const [isOpenAccepte, setIsOpenAccpte] = useState(false)
    const [isOpenRefuse, setIsOpenRefuse] = useState(false)
    const [isLoading, setIsLoading] = useState(false);

    const handleItemClick = async (id) => {

        const details_ = await fetchDetailComande(id)

 
        setDetails(details_)
        //   setDetails([
        //     {
        //         "id": "175805",
        //         "designation": "Pate all arabiata\n",
        //         "label": "",
        //         "prix_unitaire": "74.00",
        //         "prix_promo": "10.00",
        //         "quantite": "1",
        //         "is_formule": "0",
        //         "commande_id": "175805",
        //         "restaurant_id": "403",
        //         "prix_id": "3638",
        //         "produit_id": "4720",
        //         "remark": "",
        //         "created_at": "2024-01-25 14:51:49",
        //         "updated_at": "2024-01-25 14:51:49",
        //         "purchased_product_id": "MTA0ODY0NDE3ODg0",
        //         "uuid": "038108380088",
        //         "user_id": "0",
        //         "prix_total": "79",
        //         "moneyBackMontant": "0",
        //         "reduction": "-10",
        //         "tips": "0",
        //         "service": "0",
        //         "frais_de_livraison": "0",
        //         "note": "769 ",
        //         "quartier": "",
        //         "status": "0",
        //         "moyen_paiement": "0",
        //         "point": "GLOVO",
        //         "version": null,
        //         "callback": "0",
        //         "id_transaction_cmi": null,
        //         "type": "0",
        //         "wizard": "0",
        //         "picker": "",
        //         "timepick": "2024-01-25 16:01:30",
        //         "datepick": null,
        //         "table": "-1",
        //         "id_livreur": "-1",
        //         "fleet_id": null,
        //         "date_arrive": "",
        //         "date_livraison": "",
        //         "virement_envoye": "NON PAYE",
        //         "debut_periode": null,
        //         "fin_periode": null,
        //         "date_virement": null,
        //         "dates_acceptation": null,
        //         "dates_livraison": null,
        //         "dates_fin_course": null,
        //         "dates_annulation": null,
        //         "dates_annulation_livreur": null,
        //         "annulation_client": "0",
        //         "annulation_livreur": "0",
        //         "nom": "Nizar C.",
        //         "prenom": "GLOVO",
        //         "email": "glovo@lacaisse.ma",
        //         "telephone": "Nizar C.",
        //         "adresse": "",
        //         "latitude": "0",
        //         "longitude": "0",
        //         "token": null,
        //         "matricule": null,
        //         "classe": null,
        //         "channelid": "EKHDKHDKHA",
        //         "STAN": null,
        //         "date_releve": null,
        //         "pickupurl": null,
        //         "date_start_task": null,
        //         "date_debut_pickup": null,
        //         "date_arrive_pickup": null,
        //         "date_fin_pickup": null,
        //         "date_debut_delivery": null,
        //         "date_fin_delivery": null,
        //         "date_arrive_delivery": null,
        //         "livreur_affecte": null,
        //         "status_pickup": "NON ASSIGNE",
        //         "status_delivery": "NON ASSIGNE",
        //         "id_caisse_accepted": null,
        //         "livreurRate": null,
        //         "restaurantRate": null,
        //         "statusRate": "0",
        //         "utm": "637666",
        //         "remuneration": "10",
        //         "id_prix": "3638",
        //         "id_produit": "4720",
        //         "prix": "69",
        //         "tva": "10",
        //         "etat": "1",
        //         "last_update": "05-01-2024 10:07:55",
        //         "code_bar": "4964672792669",
        //         "id_caisse": "403",
        //         "url_image_prix": "",
        //         "isvendablelivraison": "1",
        //         "isvendabledeliverect": "1",
        //         "purchased_product_idd": "MTA0ODY0NDE3ODg0",
        //         "idd": "1540904",
        //         "date_commande": "2024-01-25 14:51:49",
        //         "formule": []
        //     }, {
        //         "id": "175805",
        //         "designation": "Pate all arabiata\n",
        //         "label": "",
        //         "prix_unitaire": "74.00",
        //         "prix_promo": "10.00",
        //         "quantite": "1",
        //         "is_formule": "0",
        //         "commande_id": "175805",
        //         "restaurant_id": "403",
        //         "prix_id": "3638",
        //         "produit_id": "4720",
        //         "remark": "",
        //         "created_at": "2024-01-25 14:51:49",
        //         "updated_at": "2024-01-25 14:51:49",
        //         "purchased_product_id": "MTA0ODY0NDE3ODg0",
        //         "uuid": "038108380088",
        //         "user_id": "0",
        //         "prix_total": "79",
        //         "moneyBackMontant": "0",
        //         "reduction": "-10",
        //         "tips": "0",
        //         "service": "0",
        //         "frais_de_livraison": "0",
        //         "note": "769 ",
        //         "quartier": "",
        //         "status": "0",
        //         "moyen_paiement": "0",
        //         "point": "GLOVO",
        //         "version": null,
        //         "callback": "0",
        //         "id_transaction_cmi": null,
        //         "type": "0",
        //         "wizard": "0",
        //         "picker": "",
        //         "timepick": "2024-01-25 16:01:30",
        //         "datepick": null,
        //         "table": "-1",
        //         "id_livreur": "-1",
        //         "fleet_id": null,
        //         "date_arrive": "",
        //         "date_livraison": "",
        //         "virement_envoye": "NON PAYE",
        //         "debut_periode": null,
        //         "fin_periode": null,
        //         "date_virement": null,
        //         "dates_acceptation": null,
        //         "dates_livraison": null,
        //         "dates_fin_course": null,
        //         "dates_annulation": null,
        //         "dates_annulation_livreur": null,
        //         "annulation_client": "0",
        //         "annulation_livreur": "0",
        //         "nom": "Nizar C.",
        //         "prenom": "GLOVO",
        //         "email": "glovo@lacaisse.ma",
        //         "telephone": "Nizar C.",
        //         "adresse": "",
        //         "latitude": "0",
        //         "longitude": "0",
        //         "token": null,
        //         "matricule": null,
        //         "classe": null,
        //         "channelid": "EKHDKHDKHA",
        //         "STAN": null,
        //         "date_releve": null,
        //         "pickupurl": null,
        //         "date_start_task": null,
        //         "date_debut_pickup": null,
        //         "date_arrive_pickup": null,
        //         "date_fin_pickup": null,
        //         "date_debut_delivery": null,
        //         "date_fin_delivery": null,
        //         "date_arrive_delivery": null,
        //         "livreur_affecte": null,
        //         "status_pickup": "NON ASSIGNE",
        //         "status_delivery": "NON ASSIGNE",
        //         "id_caisse_accepted": null,
        //         "livreurRate": null,
        //         "restaurantRate": null,
        //         "statusRate": "0",
        //         "utm": "637666",
        //         "remuneration": "10",
        //         "id_prix": "3638",
        //         "id_produit": "4720",
        //         "prix": "69",
        //         "tva": "10",
        //         "etat": "1",
        //         "last_update": "05-01-2024 10:07:55",
        //         "code_bar": "4964672792669",
        //         "id_caisse": "403",
        //         "url_image_prix": "",
        //         "isvendablelivraison": "1",
        //         "isvendabledeliverect": "1",
        //         "purchased_product_idd": "MTA0ODY0NDE3ODg0",
        //         "idd": "1540904",
        //         "date_commande": "2024-01-25 14:51:49",
        //         "formule": []
        //     }
        // ]);
        setSelectedDetailId(id === selectedDetailId ? null : id); // Toggle visibility
    };

    const accepterCommande = () => {
        updateCommandeStatus(selectedDetailId , 1)
        const frais_livraison = items.find(item =>item.id == selectedDetailId )?.frais_de_livraison || 0 
        setFraisGlobal(frais_livraison)

        const newPanel = []

        details.map(detail => {

            // Convert reduction to a number and check if it's not 0. Though, given "-10", it's always true in this context.
            const reductionPercentage = parseFloat(detail?.reduction || 0) / 100;
            let price = detail.prix_promo !=0 ? detail.prix_promo  : detail.prix_total;
            let discountedPrice =  detail.prix_promo !=0 ? detail.prix_promo  : detail.prix_total;

            // If reduction is not 0, apply the discount. Since "-10" is always truthy, this condition always passes.
            // if (detail?.reduction !== "0") {
            //     price = price * (1 + reductionPercentage); // Adjust price based on reduction.
            //     discountedPrice = discountedPrice * (1 + reductionPercentage); // Adjust discountedPrice similarly.
            // }

            const object = {
                id: detail?.prix_id,
                id_produit: detail.produit_id,
                id_prix: detail?.prix_id,
                name: detail?.designation,
                id_categorie: "-1",
                code: detail?.code_bar,
                price: price,
                statut: 1,
                quantity:  parseInt(detail?.quantite) ,
                discountedPrice: discountedPrice,
                id_remise: null,
                typeCommande: true
            };
            newPanel.push(object)
        })

        setProductPanier(newPanel)
       
        setIsOpenAccpte(false)
        onClickSiteCommadeModal()
    }

    const accepteConfirmation = () => {

        if (productsPanier.filter(p=>p.statut == 1).length != 0) {
            setIsOpenAccpte(true)
        } else {
            accepterCommande()
            onClickSiteCommadeModal()
        }

    }


    const refuseConfirmation = ()=>{
        updateCommandeStatus(selectedDetailId , 3)
        openRefuseModal()
    }

   const  openRefuseModal = ()=>{
    setIsOpenRefuse(!isOpenRefuse)
   }

 
    useEffect(() => {
        fetchDataCommande();
    }, []);


    const fetchDataCommande = async (id) => {
        setIsLoading(true); // Step 2: Start loading
        const response = await fetchListCommandeSite();
        const data = await response;
        setItems(data);
        setIsLoading(false); // Stop loading once the data is fetched
    };

    return (
        <div>
            <Modal
                aria-labelledby="example-custom-modal-styling-title"
                show={commandeShow}
                onHide={() => onClickSiteCommadeModal()}
            >
                <div className="modal-content-inner">
                    <ModalHeader>    <div className='title-commandes'>List des commandes</div></ModalHeader>
                    {/* <div className="modal-header-inner">Items List</div> */}
                    <ModalBody>
                      

                        {isLoading ? (
                        
                            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", height: "100%", width: "100%" }}>

                            <Lottie
                                options={defaultOptions}
                                height={250}
                                width={250}



                            />
                        </div>// Step 3: Display loader
                        ) : items.length > 0 ? (
                            <div className="items-container">
                                {/* Map through items and display them */}
                                <div className="items-container" >

{items.map(({ id, prix_total, channel, created_at }) => (
    <React.Fragment key={id}>
        <div className="item" onClick={() => handleItemClick(id)}>
            <div className="item-header">
                <span className="item-title">ID: {id}</span>
                <span className="item-price">Total: {prix_total} MAD</span>
            </div>
            <div className="item-details">
                <span className="item-channel">Channel: {channel}</span>
                <span className="item-date">Date: {new Date(created_at).toLocaleDateString()}</span>
            </div>
        </div>
        {selectedDetailId === id && (
            <div className="detail-view">

                <DetailView details={details} accepterCommande={accepterCommande} openRefuseModal={openRefuseModal} accepteConfirmation={accepteConfirmation} />


            </div>
        )}
    </React.Fragment>
))}
</div>
                            </div>
                        ) : (
                            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", height: "100%", width: "100%" }}>

                            <Lottie
                                options={defaultOptions_}
                                height={250}
                                width={250}
                            />
                        </div>// Step 4: Display "No Data" if items are empty
                        )}
                    </ModalBody>
                </div>
                <ModalFooter>
                    <button  className='btn btn-danger' onClick={onClickSiteCommadeModal}>Fermer</button>
                </ModalFooter>

            </Modal>
            {isOpenAccepte && <EditHoldConfirmationModal onConfirm={accepterCommande} onCancel={() => { setIsOpenAccpte(false) }} icon={warning} title={"Accepter la commande"} itemName={"globally.detail.product"} />}
            {isOpenRefuse && <EditHoldConfirmationModal onConfirm={refuseConfirmation} onCancel={() => { setIsOpenRefuse(false) }} icon={warning} title={"Refuser la commande"} itemName={"globally.detail.product"} />}
        </div>

    )
}

const DetailView = ({ details, accepterCommande, openRefuseModal , accepteConfirmation }) => (
    <div className="detail-view">
        {details.map((detail, index) => (
            
            <div key={index} className="detail-item">
                <div className="designation">{detail.designation.trim()}</div>
                <div className="price-info">
                    <span className="quantity-price">{`${detail.quantite} * ${ detail.prix_promo !=0 ? detail.prix_promo  : detail.prix_total} MAD`}</span>
                    {detail.reduction > 0 && (
                        <span className="reduction">{`-${detail.reduction}%`}</span>
                    )}
                    <span className="final-price">{`Total: ${(detail.prix_promo !=0 ? detail.prix_promo  : detail.prix_total) * detail.quantite} MAD`}</span>
                </div>
            </div>
        ))}

        <div className='buttons_actions_'>
            <button className="accept-button accept-button_accepter" onClick={() => accepteConfirmation()}>Accepter</button>
            <button className=" accept-button accept-button_refuser" onClick={openRefuseModal}>Refuser</button>

        </div>
    </div>
);


export default CommandeSiteModal;
